import { ExplorePluginButton } from '~/portal/components/ApiViewer/ExplorePlugin/ExplorePluginButton'

interface ExplorePluginData {
  version: string,
  exploreUrl: string,
  swaggerhubOrgName: string,
  swaggerhubApiName: string,
  oasVersion: string
}

export const ExplorePlugin = ({ version, swaggerhubOrgName, exploreUrl, swaggerhubApiName, oasVersion }: ExplorePluginData) => () => ({
  wrapComponents: {
    JumpToPath: Original => props => (
      <div className="flex">
        <Original {...props} />
        <ExplorePluginButton {...props} version={version} swaggerhubOrgName={swaggerhubOrgName} exploreUrl={exploreUrl} swaggerhubApiName={swaggerhubApiName} oasVersion={oasVersion} />
      </div>
    )
  }
})